export function usePageInit() {
  window.scrollTo({ top: 0 });
}
